import { Component } from '@angular/core';

@Component({
  selector: 'app-token-invalido',
  standalone: true,
  imports: [],
  templateUrl: './token-invalido.component.html',
  styleUrl: './token-invalido.component.scss'
})
export class TokenInvalidoComponent {

}
